import { useState, useEffect } from 'react';
import store2 from 'store2';



const usePersistState = (storageKey, initialState) => {
  const [state, setInternalState] = useState(initialState);

  useEffect(() => {
    const storageInBrowser = store2.get(storageKey);
    if (storageInBrowser) {
      setInternalState(storageInBrowser);
    }

  }, []);

  const setState = (newState) => {
    store2.set(storageKey, newState);
    setInternalState(newState);
  };

  return [state, setState];

};

export default usePersistState;